
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import Button from "../../components/utils/Button";
import { Link } from "react-router-dom";
import CardLayout from "../../components/utils/CardLayout";
// import { useDispatch, useSelector } from "react-redux";

const MDNSwap = () => {

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
  } = useForm({
    mode: "onChange",
    defaultValues: {
      serialnumber: "",
      msisdnnumber: "",
      zipCode: "",
    },
  });

  const onSubmit = async (data) => {
    console.log(data);

  };

  const handleReset = () => {
    reset();
  
  };


  return (
    <CardLayout
      title={<> MSISDN Swap</>}
      
      icon="fas fa-retweet menu-icon "
    >
      <div className="row">
      
        {/* center Side */}
        <div className="col-lg-12">
          <form
            onSubmit={handleSubmit(onSubmit)}
            noValidate
          >
            <div className="row">
              {/* Serial Number */}
              <div className="col-lg-3 mb-2">
                <label className="form-label fw-semibold">
                  Serial Number <span className="text-danger">*</span>
                </label>

                <input
                  type="text"
                  className={`form-control ${errors.serialnumber ? "is-invalid" : ""
                    }`}
                  placeholder="Serial Number"
                  {...register("serialnumber", {
                    required: "Serial Number is required",
                    pattern: {
                      value: /^[0-9]{19}$/,
                      message: "Serial Number must be exactly 19 digits",
                    },
                  })}
                  onInput={(e) => {
                    e.target.value = e.target.value.replace(/\D/g, ""); // allow only numbers
                  }}
                />

                <div className="invalid-feedback"> {errors.serialnumber?.message} </div>
              </div>

                {/* MDN Number */}
              <div className="col-lg-3 mb-2"
              >
                <label className="form-label fw-semibold">
                  MSISDN <span className="text-danger">*</span>
                </label>

                <input
                  type="text"
                  className={`form-control ${errors.msisdn ? "is-invalid" : ""
                    }`}
                  placeholder="msisdn"
                  {...register("msisdn", {
                    required: "msisdn Code is required",
                  })}
                />

                <div className="invalid-feedback"> {errors.msisdn?.message} </div>
              </div>

              {/* Zip Code */}
              <div className="col-lg-3 mb-2"
              >
                <label className="form-label fw-semibold">
                  ZIP Code <span className="text-danger">*</span>
                </label>

                <input
                  type="text"
                  className={`form-control ${errors.zipCode ? "is-invalid" : ""
                    }`}
                  placeholder="ZIP Code"
                  {...register("zipCode", {
                    required: "ZIP Code is required",
                    // pattern: {
                    //   value: /^\d{5}(-\d{4})?$/,
                    //   message: "Invalid ZIP Code",
                    // },
                  })}
                />

                <div className="invalid-feedback"> {errors.zipCode?.message} </div>
              </div>

              {/* Submit */}
                       <div className="col-md-3 d-flex align-items-end" style={{ height: '70px' }}>
                         <div className="d-flex gap-3">
                           <Button
                             title="MSISDN Swap"
                             buttonType="submit"
                             variant="primary"
                              icon={<i className="fas fa-exchange-alt menu-icon me-2"></i>}
                           />
                           <Button
                             title="Reset"
                             buttonType="button"
                             variant="secondary"
                             icon={<i className="ri-refresh-line me-2"></i>}
                             onClick={handleReset}
                           />
                         </div>
                       </div>
            </div>
          </form>
        </div>
      </div>
    </CardLayout>
  );
};

export default MDNSwap;
